module.exports = __webpack_public_path__ + "static/media/waiting.b5ccde02.svg";